import React, { Component } from 'react'
import axios from 'axios'
import { BrowserRouter, Route, Switch } from 'react-router-dom'
import '../scss/style.scss'
import '../css/coreui.css'
import '../css/DatePicker.css'
import { GlobalProvider } from '../views/context/GlobalState'
import { dispatchAlert } from '../Redux/Actions/authAction'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { configure } from 'axios-hooks'
import { AppProvider } from '../views/context/app'
import { AlertComponent } from '../components'
import { ToastContainer } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import Login from '../views/container/login'
import Register from '../views/container/register/Register'
import Page404 from '../views/container/page404/Page404'
import Page500 from '../views/container/page500/Page500'
import AppMainContainer from './appMainContainer'
import ResetPassword from 'src/views/container/resetPassword/resetPassword'

class App extends Component {
  render() {
    axios.interceptors.request.use(
      (req) => {
        let accountId = localStorage.getItem('accountId')
        let sessionId = localStorage.getItem('sessionId')
        let language = localStorage.getItem('language')
        let defaultLanguage = localStorage.getItem('default_language')
        if (language) {
          req.headers['language'] = language
        }
        if (defaultLanguage) {
          req.headers['default-language'] = defaultLanguage
        }
        if (accountId) {
          req.headers[`account-id`] = accountId
          req.headers[`ott-sessionid`] = sessionId
        }
        return req
      },
      (error) => {
        return Promise.reject(error)
      },
    )
    axios.interceptors.response.use(
      (response) => {
        return response
      },
      (error) => {
        if (error?.response?.status) {
          this.props.dispatchAlert(
            'danger',
            `Error ${error?.response?.status}`,
            `${error?.response?.data?.message}`,
            true,
          )
        }
        return Promise.reject(error)
      },
    )

    configure({ axios })
    return (
      <AppProvider>
        <GlobalProvider>
          <BrowserRouter>
            <ToastContainer />
            {this.props.showAlert && <AlertComponent />}
            <Switch>
              <Route
                exact
                path="/login"
                name="Login Page"
                render={(props) => <Login {...props} />}
              />
              <Route
                exact
                path="/register"
                name="Register Page"
                render={(props) => <Register {...props} />}
              />
              <Route
                exact
                path="/reset-password"
                name="Reset Password Page"
                render={(props) => <ResetPassword {...props} />}
              />
              <Route exact path="/404" name="Page 404" render={(props) => <Page404 {...props} />} />
              <Route exact path="/500" name="Page 500" render={(props) => <Page500 {...props} />} />
              <Route path="/" name="Home" render={(props) => <AppMainContainer {...props} />} />
            </Switch>
          </BrowserRouter>
        </GlobalProvider>
      </AppProvider>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    showAlert: state.sweetAlertReducer.showAlert,
    data: state.sweetAlertReducer.data,
  }
}

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators({ dispatchAlert }, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(App)
